import { useContext } from 'react';
import { ClinicContext } from '../context/clinic';

export const useClinicContext = () => {
    const context = useContext(ClinicContext);
    if (context === undefined) {
        throw new Error('useClinicContext must be used within an ClinicProvider');
    }
    return context;
};